export const KITEMAKER_ACTOR_ID = '__kitemaker__';
export const ONBOARDING_ACTOR_ID = '__onboarding1__';
